/* eslint-disable no-debugger */

import classNames from 'classnames';
import deepEqual from 'deep-equal';
import shallowEqual from 'fbjs/lib/shallowEqual';
import stableStringify from 'json-stable-stringify';

const isDevelopment = process.env.NODE_ENV === 'development';

function assert(condition, ...args) {
	if (isDevelopment && !condition) {
		args = args || [];
		let msg = 'Assertion failed! Context:\n' + args.map(a => mg.stringify(a)).join('\n---------\n');
		throw new Error(msg);
	}
}

const isArray = Array.isArray;
function isObject(value) {return value !== null && typeof value === 'object';}
function isString(value) {return typeof value === 'string';}
function isNumber(value) {return typeof value === 'number';}
function isFunction(value) {return typeof value === 'function';}
const isNullOrUndefined = value => value == null;

function stringify(o) {
	let result = stableStringify(o, {space: 4});
	if (!result) return 'undefined';
	result = result.replace(/\[\n\s*\]/g, '[]');
	result = result.replace(/\{\n\s*\}/g, '{}');
	return result;
}

function extract(object, path) {//TODO duplicate
	mg.assert(mg.isString(path), object, path);
	if (!path) return object;
	let result = object;
	path.split('.').forEach(x => result = result[x]);
	return result;
}

function entriesToObject(entries) {
	var result = {};
	entries.forEach(e => result[e[0]] = e[1]);
	return result;
}

function comparatorOn<T, U>(f: (t: T) => U) {
	return (a: T, b: T) => {
		const a2: U = f(a);
		const b2: U = f(b);
		return a2 < b2 ? -1 : a2 > b2 ? +1 : 0;
	};
}

function caseHalfSensitiveCompare(a: string, b: string) {
	const a2 = a.toLowerCase();
	const b2 = b.toLowerCase();
	if (a2 < b2) return -1;
	if (a2 > b2) return +1;
	if (a < b) return -1;
	if (a > b) return +1;
	return 0;
}

var _etagCounter = 1;

function newEtag() {
	return '_' + _etagCounter++;
}

function promiseAfter(delay) {
	return new Promise((resolve) => setTimeout(resolve, delay));
}

const storage = {
	get: (key: string, def?: any) => {
		try {
			const s = localStorage.getItem(key);
			if (!s) return def;
			var result = JSON.parse(s);
			return result || result==='' ? result : def;
		} catch (e) {
			return def;
		}
	},

	put: (key: string, value: any) => {
		if (value===undefined) {
			localStorage.removeItem(key);
		} else {
			localStorage.setItem(key, JSON.stringify(value));
		}
	}
};

function clearSelectionIn(node) {
	if (!window.getSelection) return;
	const s = window.getSelection();
	if (!s) return;
	for (let n:any=s.focusNode; n; n=n.parentNode) {
		if (n !== node) continue;
		s.removeAllRanges();
		return;
	}
}

function freezeIfDevelopment<T>(o: T) : T {
	return isDevelopment ? Object.freeze(o) : o;
}

function parseJson(json) {
	if (json) json = json.substring(json.startsWith(')]}\'\n') ? 5 : 0);
	return JSON.parse(json);
}

const clsn = classNames;

function delayed<T>(millis: number, value: T) : Promise<T> {
	return new Promise(resolve => setTimeout(() => resolve(value), millis));
}

function formatProblemInfo(where: string, info: Array<any>) {
	const s = info.map((a: any) => isFunction(a) ? a() : a).map(a => '\n---------\n' + mg.stringify(a)).join('');
	return where + s;
}

const assertTrue = (x: any, ...info: Array<any>) : boolean => {
	if (x) return true;
	console.error(formatProblemInfo('assertTrue', info));
	if (isDevelopment) debugger;
	return false;
};

const checkTrue = <T>(x: any, ...info: Array<any>) : true => {
	if (x) return true;
	if (isDevelopment) debugger;
	throw new Error(formatProblemInfo('checkTrue', info));
};

const assertFalse = (x: any, ...info: Array<any>) : boolean => {
	if (!x) return false;
	console.error(formatProblemInfo('assertFalse', info));
	if (isDevelopment) debugger;
	return true;
};

const checkFalse = <T>(x: any, ...info: Array<any>) : false => {
	if (!x) return false;
	if (isDevelopment) debugger;
	throw new Error(formatProblemInfo('checkFalse', info));
};

const isPresent = <T>(x: T | undefined | null) : x is T => x != undefined;

const assertPresent = <T>(x: T | undefined | null, ...info: Array<any>) : x is T => {
	if (x != undefined) return true;
	console.error(formatProblemInfo('assertPresent', info));
	if (isDevelopment) debugger;
	return false;
};

const checkPresent = <T>(x: T | undefined | null, ...info: Array<any>) : x is T => {
	if (x != undefined) return true;
	if (isDevelopment) debugger;
	throw new Error(formatProblemInfo('checkPresent', info));
};

function capitalize(s: string) : string {
	return s.length ? s[0].toUpperCase() + s.substring(1) : s;
}

export const mg = {
	clsn,
	freezeIfDevelopment,
	assert,
	caseHalfSensitiveCompare,
	deepEqual,
	entriesToObject,
	extract,
	isArray,
	isDevelopment,
	isFunction,
	isNumber,
	isNullOrUndefined,
	isObject,
	isString,
	newEtag,
	promiseAfter,
	storage,
	stringify,
	clearSelectionIn,
	comparatorOn,
	shallowEqual,
	parseJson,
	delayed,
	isPresent,
	assertPresent,
	checkPresent,
	assertTrue,
	checkTrue,
	assertFalse,
	checkFalse,
	capitalize,
};
